import { OrganizationConfig } from '@tenants/types/tenant';
import { LOCALE_EXP_REALTY_US_PATHS } from 'types/locales';
import { EXP_REALTY_INTERNATIONAL_LINKS } from '@tenants/definitions/exp/shared/international-links';

export function createOrganizationConfig(): OrganizationConfig {
  return {
    phoneNumber() {
      return '1 833-303-0610';
    },
    email() {
      return 'info@exprealty.net';
    },
    address(_options) {
      return '2219 Rimland Drive, Suite 301,\nBellingham, Washington, 98226';
    },
    twitterUrl: 'https://x.com/exprealty',
    facebookUrl: 'https://www.facebook.com/eXpRealty/',
    instagramUrl: 'https://www.instagram.com/exprealty',
    linkedinUrl: 'https://www.linkedin.com/company/exp-realty',
    youtubeUrl: 'https://www.youtube.com/@eXpRealty',
    joinSectionUrl: '/join-exp',
    internationalLinks: {
      title: LOCALE_EXP_REALTY_US_PATHS.INTERNATIONAL_MODAL_TITLE,
      subtitle: LOCALE_EXP_REALTY_US_PATHS.INTERNATIONAL_MODAL_SUBTITLE,
      linkData: EXP_REALTY_INTERNATIONAL_LINKS,
    },
  };
}
